import React from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { CartIcon } from "./CartIcon";
export const DualHeader = () => {
  const isMobile = useIsMobile();
  return <header className="w-full bg-white/80 backdrop-blur-sm border-b mx-0 my-0 py-0 px-4 md:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto flex items-center justify-between py-2 bg-slate-50">
        <div className="flex items-center">
          <img alt="Tribal Trails.ai" className="h-12 md:h-16 w-auto" src="/lovable-uploads/cb586a5a-c34e-44f6-bc73-ff7ac2b22289.png" />
        </div>
        <div className="flex flex-col items-center">
          <img alt="Shoshone-Paiute Tribes" src="/lovable-uploads/b388e1a9-0748-449c-a856-e8a2150e511d.png" className="h-16 md:h-20 w-auto object-scale-down" />
          <span className="text-xs text-tribal-neutral mt-1">
            Powered by Tribal Trails.ai
          </span>
        </div>
        <div className="flex items-center justify-end w-[120px]"> {/* Increased width from 100px to 120px */}
          <CartIcon />
        </div>
      </div>
    </header>;
};